import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import InputNumberNoScroll from "../../../components/inputs/inputNumberNoScroll";

// Componentes UI
import BtnGuardar from "../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../components/buttons/BtnCancelar";

// Autocompletes
import CertificadoAutocomplete from "../../../components/autocomplete/CertificadoAutocomplete";
// NOTA: Ya no importamos ProductoAutocomplete porque usaremos un input simple para solo lectura

// API
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function EditarProdCertificado({
  initial,
  onClose,
  onSaved,
}) {
  // --- ESTADOS ---
  const [certificadoObj, setCertificadoObj] = useState(null);
  const [productoObj, setProductoObj] = useState(null); 
  const [qnProducto, setQnProducto] = useState("");
  const [valorMontoDescuento, setValorMontoDescuento] = useState("");
  const [qnUtilizado, setQnUtilizado] = useState("");

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  // =======================================================
  // INICIALIZACIÓN
  // =======================================================
  useEffect(() => {
    if (initial) {
      // 1. Cargar Certificado
      if (initial.certificadoId) {
        setCertificadoObj({
          id: initial.certificadoId,
          numero: initial.certificadoNumero
        });
      }

      // 2. Cargar Producto
      if (initial.productoId) {
          setProductoObj({
              id: initial.productoId,
              nombre: initial.productoNombre,
              codigo: initial.productoCodigo 
          });
      }

      // 3. Cargar valores simples
      setQnProducto(initial.qnProducto || "");
      setValorMontoDescuento(initial.valorMontoDescuento || "");
      setQnUtilizado(initial.qnUtilizado || "0");
    }
  }, [initial]);

  // Validación
  const isValid =
    certificadoObj !== null &&
    productoObj !== null && 
    qnProducto !== "" &&
    valorMontoDescuento !== "";

  // Cerrar con ESC
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  // Guardar (Edición)
  const handleSave = async () => {
    if (!isValid || saving) return;

    setError("");
    setSaving(true);

    try {
      const payload = {
        id: initial.id, 
        certificadoId: certificadoObj.id,
        productoId: productoObj.id,
        qnProducto: Number(qnProducto),
        valorMontoDescuento: Number(valorMontoDescuento),
        qnUtilizado: Number(qnUtilizado),
        codigoAnio: 0
      };
      
const url = apiRoutes.certificadoDetalles.update(initial.id); 

      const updated = await appFetchJson(url, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      onSaved(updated);
      onClose();
    } catch (e) {
      console.error("Error editando detalle:", e);
      setError(e?.message || "Error al actualizar el registro.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      
      <div className="modal-panel-lg" onClick={(e) => e.stopPropagation()}>
        
        {/* HEADER */}
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">Editar Detalle</h2>
          <button className="modal-close-x" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        {/* BODY */}
        <div className="modal-body">
          <p className="text-gray-600 mb-4 italic">
            Edite los valores del producto asignado.
          </p>

          {error && <div className="text-red-600 mb-3 font-medium">{error}</div>}

          <div className="form-grid">
            
            {/* 1. CERTIFICADO (READONLY) */}
            <div className="form-row col-span-2">
              <label className="form-label">Impuesto al Valor Selectivo (Certificados)*:</label>
              <input 
                 type="text"
                 className="input w-full bg-gray-100 text-gray-700 cursor-not-allowed"
                 value={certificadoObj?.numero || ""}
                 readOnly
                 disabled
              />
            </div>

            {/* 2. PRODUCTO (AHORA ES UN INPUT SIMPLE READONLY) */}
            <div className="form-row col-span-2">
              <label className="form-label">Producto Asignado *</label>
              {/* CAMBIO: Reemplazamos ProductoAutocomplete por un input nativo.
                 Esto garantiza que sea gris, readonly y sin la "X" de limpiar.
              */}
              <input 
                 type="text"
                 className="input w-full bg-gray-100 text-gray-700 cursor-not-allowed"
                 value={productoObj?.nombre || ""} // Mostramos solo el nombre
                 readOnly
                 disabled
              />
            </div>

           {/* 3. CANTIDAD */}
            <div className="form-row col-span-2">
              <label className="form-label">Cant. del Producto (para c/u) *</label>
              <InputNumberNoScroll
                className="input w-full h-[38px] bg-white border rounded px-3"
                value={qnProducto}
                onChange={(e) => setQnProducto(e.target.value)}
              />
            </div>

            {/* 4. MONTO DESCUENTO */}
            <div className="form-row col-span-2">
              <label className="form-label">Monto del descuento (para c/u) *</label>
              <InputNumberNoScroll
                className="input w-full h-[38px] bg-white border rounded px-3"
                value={valorMontoDescuento}
                onChange={(e) => setValorMontoDescuento(e.target.value)}
              />
            </div>

            {/* 5. UTILIZADO */}
            <div className="form-row col-span-2">
              <label className="form-label">Utilizado hasta el momento: (Inicial)</label>
              <input
                type="number"
                className="input w-1/2 bg-gray-200 text-gray-500 cursor-not-allowed"
                value={qnUtilizado}
                readOnly
                onChange={(e) => setQnUtilizado(e.target.value)}
              />
            </div>

          </div>
        </div>

        {/* FOOTER */}
        <div className="modal-footer">
          <div className="btn-row">
            <BtnGuardar
              label="Guardar Cambios"
              isValid={isValid}
              saving={saving}
              onClick={handleSave}
            />
            <BtnCancelar onClick={onClose} />
          </div>
        </div>
      </div>
    </div>
  );
}